import { render, staticRenderFns } from "./package-carrier-label.vue?vue&type=template&id=b1b65e9e&scoped=true"
import script from "./package-carrier-label.vue?vue&type=script&setup=true&lang=js"
export * from "./package-carrier-label.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b65e9e",
  null
  
)

export default component.exports